export const isAbortError = (error) =>
  error?.name === "AbortError" || error?.code === "ERR_CANCELED";

export const isLikelyNetworkError = (error) => {
  if (!error || isAbortError(error)) {
    return false;
  }

  if (error?.code === "ERR_NETWORK") {
    return true;
  }

  if (error?.isAxiosError) {
    return !error.response;
  }

  return error instanceof TypeError;
};

export const getNetworkErrorMessage = ({
  isOffline = false,
  isTimedOut = false,
} = {}) => {
  if (isOffline) {
    return "You appear to be offline. Reconnect to continue.";
  }

  if (isTimedOut) {
    return "This request is taking longer than expected. Please check your connection and try again.";
  }

  return "We couldn't load because of a network issue. Check your connection and try again.";
};
